import React from 'react';
import { BoltIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { HERO_IMG, OFFER_ANCHOR } from '../data/constants';
const countChips = ['1 Système Principal', '5 Bonus Stratégiques', '6 Modules Complets'];
const audienceChips = ['Orthophonistes Expérimentés', 'Enfants, Adolescents & Adultes'];
export function Hero() {
  return <section className="bg-petrol px-4 pb-8 pt-6 sm:px-6 sm:pb-10 sm:pt-8" data-id="element-111" data-mp="1297c23jh2z9b">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="127ec173d7daa">
        <p className="inline-block rounded-full border border-gold/50 px-3 py-1 font-display text-[10px] font-bold uppercase tracking-[0.16em] text-gold sm:text-xs" data-id="element-113" data-mp="xbfmvha7pr8t">
          Le système professionnel complet pour les orthophonistes
        </p>
        <h1 className="mx-auto mt-3 max-w-3xl text-[19px] font-extrabold leading-[1.15] text-white sm:text-[26px] lg:text-[32px]" data-id="element-114" data-mp="nekn6v27dksy">
          Préparez votre prochaine séance avec une{' '}
          <span className="text-gold" data-id="element-115" data-mp="384jssxvrzhse">structure clinique claire</span>, sans repartir de zéro.
        </h1>
        <p className="mx-auto mt-2.5 max-w-3xl text-[13px] leading-snug text-cream/85 sm:text-base" data-id="element-116" data-mp="3j6fw9kdl53b7">
          Votre système professionnel complet 6-en-1 : évaluation clinique, projets thérapeutiques,
          bibliothèque d’interventions, séances prêtes à adapter, programmes de prise en soin, suivi
          clinique et outils de coordination.
        </p>

        <a href={OFFER_ANCHOR} aria-label="Voir l’offre Orthophonie Pro" className="mt-3 block" data-id="element-117" data-mp="30gztsricb0s5">
          <img src={HERO_IMG} alt="Le système Orthophonie Pro : six modules, tablette, ordinateur et smartphone" className="mx-auto w-full max-w-lg transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-118" data-mp="359sy5e9wc73p" />
        </a>

        <div className="mt-3 space-y-1" data-id="element-119" data-mp="2hin9qapw46hs">
          <ul className="flex flex-nowrap items-center justify-center gap-x-2.5 sm:gap-x-5" data-id="element-120" data-mp="2hjoz7k7nkvj1">
            {countChips.map(chip => <li key={chip} className="flex items-center gap-1 whitespace-nowrap text-[10px] font-semibold text-cream sm:text-sm" data-id="element-121" data-mp="2lmlcqwic61g4">
                <ShieldCheckIcon aria-hidden="true" className="h-3 w-3 shrink-0 text-gold sm:h-4 sm:w-4" data-id="element-122" data-mp="na060pwkyn9y" />
                {chip}
              </li>)}
          </ul>
          <ul className="flex flex-nowrap items-center justify-center gap-x-2.5 sm:gap-x-5" data-id="element-123" data-mp="degd8cdbc4pf">
            {audienceChips.map(chip => <li key={chip} className="flex items-center gap-1 whitespace-nowrap text-[10px] font-semibold text-cream sm:text-sm" data-id="element-124" data-mp="1ayjg9az6xa4o">
                <ShieldCheckIcon aria-hidden="true" className="h-3 w-3 shrink-0 text-gold sm:h-4 sm:w-4" data-id="element-125" data-mp="110wpnr8j3u4v" />
                {chip}
              </li>)}
          </ul>
        </div>

        <CTAButton variant="gold" className="mx-auto mt-4 max-w-md" data-id="element-126" data-mp="3lui9cqv5izld">
          Accédez à Orthophonie Pro™ maintenant
        </CTAButton>
        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-cream/80 sm:text-xs" data-id="element-127" data-mp="1x9b590wn91ck">
          <li className="flex items-center gap-1.5" data-id="element-128" data-mp="21bxx31tbem9r">
            <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-129" data-mp="269zi3saawvnv" /> Paiement Sécurisé
          </li>
          <li className="flex items-center gap-1.5" data-id="element-130" data-mp="2b0fwpfpuynbt">
            <BoltIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-131" data-mp="2b2al540c8xkn" /> Accès Immédiat
          </li>
          <li className="flex items-center gap-1.5" data-id="element-132" data-mp="2fzj3b4lhl1lw">
            <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-133" data-mp="2ky43j40qnlac" /> Garantie 7 Jours
          </li>
        </ul>
      </div>
    </section>;
}